import React, { Component } from 'react'
import HeaderTmp from '../Template/HeaderTmp'
import { Layout, Row, Col } from 'antd'
import FacebookLogin from 'react-facebook-login'
import Submission from './Submission'
import ExImage from './ExImage'
import { gql, graphql } from 'react-apollo'
import template from 'es6-template-strings'
import './style.css'
const { Content } = Layout

class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            facebook: {} ,
            status: false
        }
    }
    responseFacebook = (response) => {
        console.log(response)
        if (response.accessToken) {
            this.setState({
                status: true,
                facebook: response
            })
        }
    }

    componentDidMount() {
        document.title = "RaceLive Facebook Feed - ThaiRun"
    }
    
    render() {
        if(!this.props.data.event) {
            return <div>Loading...</div>
        }
        // const { slug } = this.props.match.params
        const { event } = this.props.data
        const detailTemplate = {
            title: event.title
        }
        let content = template(event.message.signup.content, detailTemplate)
        let subFooter = template(event.message.signup.subFooter, detailTemplate)
        return (
            <Layout style={{ background: "#ffffff" }}>
                <HeaderTmp />
                <Content style={{ padding: '0 50px', marginTop: 100 }}>
                    <Row>
                        <Col span={24} style={{textAlign:"center"}}>
                            {/* <h1>Login - {slug}</h1> */}
                            <img src={event.logoFMImage} alt={event.logoFMImage} width="200" />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{textAlign:"center"}}>
                            {this.state.status ?
                                <Submission event={this.props.data.event} facebook={this.state.facebook} /> :
                                <div className="login">
                                    {/* <h2 className="head-login">Please login</h2> */}
                                    <Row  type="flex" justify="center">
                                    <Col xs={{span:24}} sm={{span:18}} md={{span:12}} >
                                        <div className="wrap-detail">
                                            {/* <p className="detail-login">
                                                <b style={{fontSize: "20px"}}>จะสนุกแค่ไหน!</b> <br />
                                                ถ้าทันทีที่คุณวิ่งผ่านจุด checkpoint ในงาน <b>#{event.title} </b>
                                                ระบบจะโพสต์ภาพแบบนี้ที่อยู่ด้านล่าง ขึ้นไปบนเฟสบุ๊คของคุณให้อัตโนมัติ 
                                                บอกให้เพื่อนๆที่คอยติดตามดูคุณอยู่ ช่วยลุ้นช่วยเชียร์ 
                                                ทุกครั้งที่คุณก้าวข้ามพรม ในทุกๆจุด checkpoint. 
                                            </p> */}
                                            <p className="detail-login">
                                                {/* <b style={{fontSize: "20px"}}>จะสนุกแค่ไหน!</b> <br /> */}
                                                <b style={{fontSize: "20px"}}>{event.message.signup.header}</b> <br />
                                                {content}
                                            </p>
                                            <p className="detail-footer-login">
                                               {/*  เข้าร่วมความสนุกนี้ <b>Log in with Facebook</b> ที่นี่  */}
                                                {event.message.signup.footer}<br />
                                                <i>({subFooter})</i>
                                            </p>
                                        </div>
                                    </Col>
                                    </Row>
                                    <Row>
                                        <FacebookLogin
                                            appId={process.env.REACT_APP_APP_ID}
                                            autoLoad={false}
                                            scope="publish_actions,email,public_profile,manage_pages,publish_pages"
                                            callback={this.responseFacebook}
                                    />
                                    </Row>
                                    <ExImage images={event.exampleCheckpoint}/>
                                </div>
                            }
                        </Col>
                    </Row>
                </Content>
            </Layout>
        );
    }
}

const LoginQuery = gql`
    query queryEvent($slug: String){
    event(filter: {
        slug: $slug
    }){
        event
        slug
        title
        logoFMImage
        exampleCheckpoint
        message {
            signupMessage
            signup {
                header
                content
                footer
                subFooter
              }
        }
        _id
    }
    }
`
export default graphql(LoginQuery,{
    options: (props) => ({
        variables: {
            slug: props.match.params.slug
        }
    })
})(Login)



// WEBPACK FOOTER //
// ./src/Login/Login.js